import request from "./http-service";

/**
 * @Deprecated
 * 不建议直接使用，字典查询请使用 @/store/index 中的查询，避免同一接口重复调用
 * 此方法会慢慢解除调用！！！
 * 字典返回数组
 * 用于 “查询条件” | “列表数据匹配”
 */
export function toKeyValue(arr) {
  let obj = {};
  arr.forEach(el => {
    obj[el.value + ""] = el.label;
  });
  return obj;
}

/**
 * 获取指定类型的字典数据
 * @param {*} type
 * @param {*} dictType
 */
export async function getDictArray(type, dictType) {
  let response = await request(
    `/ant/v1/sys/dict/findDictDataByType?type=${dictType}`
  );
  if (type == "kv") {
    return toKeyValue(response.data);
  }
  return response.data;
}



// WEBPACK FOOTER //
// ./src/utils/sysDict.js